import { render } from "./GoalView.vue?vue&type=template&id=f0e0bc30&scoped=true"
import script from "./GoalView.vue?vue&type=script&lang=js"
export * from "./GoalView.vue?vue&type=script&lang=js"

import "./GoalView.vue?vue&type=style&index=0&id=f0e0bc30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e0bc30"]])

export default __exports__